<template>
    <div :class="`rating-scale rating-scale-align-${localAlign}`">
        <label for="rating" @click="focusFieldLabel" v-if="!editingFieldLabel">{{ displayFieldLabel }}</label>
            <input
            v-if="editingFieldLabel"
                type="text"
            class="field-label-input"
            placeholder="Bir soru girin"
                v-model="localFieldLabel"
            @blur="stopEditingFieldLabel"
            @keydown.enter="stopEditingFieldLabel"
            ref="fieldLabelInput"
            />
        <div class="scale-container">
                <div class="scale">
                <div
                    v-for="num in 5"
                    :key="num"
                    @click="setRating(num)"
                    :class="['circle', { 'rated': rating === num, 'hovered': hoveredRating === num }]"
                    @mouseenter="setHoveredRating(num)"
                    @mouseleave="clearHoveredRating"
                >
                    <span class="number">{{ num }}</span>
                    <div v-if="num === 1 || num === 5" class="label-container">
                        <p class="scale-label">{{ num === 1 ? localSubLabelOne : localSubLabelTwo }}</p>
                    </div>

                    <div v-if="rating === num" class="sparkle-effect">
                        <span class="sparkle"></span>
                        <span class="sparkle"></span>
                        <span class="sparkle"></span>
                    </div>
                </div>
            </div>

            <div class="rating-display" v-if="rating > 0">
                <div class="rating-value">
                    <span class="value">{{ rating }}</span>
                    <span class="divider">/</span>
                    <span class="max">5</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "form-rating-scale",
    props: {
        fieldLabel: String,
        align: String,
        subLabelOne: String,
        subLabelTwo: String,
        item: Object,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "top",
            localSubLabelOne: this.subLabelOne || "",
            localSubLabelTwo: this.subLabelTwo || "",
            rating: 0,
            hoveredRating: 0,
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldLabel() {
            return this.localFieldLabel || "Bir soru girin";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
            this.updateField();
        },
        setRating(value) {
            this.rating = value;
            this.updateField();
        },
        setHoveredRating(value) {
            this.hoveredRating = value;
        },
        clearHoveredRating() {
            this.hoveredRating = 0;
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                ratingScale: {
                        fieldLabel: self.localFieldLabel,
                        rating: self.rating,
                        subLabelOne: self.localSubLabelOne,
                        subLabelTwo: self.localSubLabelTwo,
                        align: self.localAlign,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        subLabelOne(newVal) {
            this.localSubLabelOne = newVal;
        },
        subLabelTwo(newVal) {
            this.localSubLabelTwo = newVal;
        },
        'item.ratingScale.rating': function (v) {
            this.rating = v;
        },
        'item.ratingScale.fieldLabel': function (v) { this.localFieldLabel = v; },
        'item.ratingScale.subLabelOne': function (v) { this.localSubLabelOne = v; },
        'item.ratingScale.subLabelTwo': function (v) { this.localSubLabelTwo = v; },
    },
};
</script>

<style lang="scss" scoped>
.rating-scale {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s ease;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    > label {
        display: block;
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin: 0 0 clamp(0.5rem, 1.2vw, 0.75rem) 0;
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        cursor: pointer;
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: rgba(55, 65, 81, 0.9);
        line-height: 1.4;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .scale-container {
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(8px);
        border: 2px solid rgba(209, 213, 219, 0.6);
        border-radius: clamp(0.75rem, 1.8vw, 1rem);
        padding: clamp(1rem, 3vw, 1.5rem);
        transition: all 0.3s ease;

        &:hover {
            border-color: #f26a52;
            box-shadow: 0 8px 25px rgba(242, 106, 82, 0.15);
        }
    }

    .scale {
        display: flex;
        justify-content: space-between;
        gap: clamp(0.75rem, 2vw, 1rem);
        margin-bottom: clamp(1rem, 2.5vw, 1.25rem);

        .circle {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: clamp(3rem, 7.5vw, 3.75rem);
            height: clamp(3rem, 7.5vw, 3.75rem);
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.3s ease;
            overflow: visible;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04),
                        inset 0 1px 2px rgba(255, 255, 255, 0.3);

            .number {
                font-size: clamp(1rem, 2.5vw, 1.25rem);
                font-weight: 600;
                color: rgba(107, 114, 128, 0.8);
                transition: all 0.3s ease;
                z-index: 2;
            }

            .label-container {
                position: absolute;
                top: clamp(4rem, 9vw, 4.6875rem);
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;

                .scale-label {
                    font-size: clamp(0.7rem, 1.5vw, 0.75rem);
                    color: rgba(107, 114, 128, 0.8);
                    margin: 0;
                    text-align: center;
                    font-weight: 500;
                    line-height: 1.3;
                }
            }

            &:hover,
            &.hovered {
                background: rgba(242, 106, 82, 0.1);
                border-color: #f26a52;
                transform: scale(1.1);
                box-shadow: 0 4px 12px rgba(242, 106, 82, 0.2);

                .number {
                    color: #f26a52;
                    transform: scale(1.1);
                }

                .scale-label {
                    color: #f26a52;
                    font-weight: 600;
                }
            }

            &.rated {
                background: #f26a52;
                border-color: #f26a52;
                box-shadow: 0 6px 20px rgba(242, 106, 82, 0.3);

                .number {
                    color: white;
                    transform: scale(1.1);
                }

                .scale-label {
                    color: #f26a52;
                    font-weight: 700;
                }

                &:hover {
                    background: #e55a42;
                    transform: scale(1.15);
                    box-shadow: 0 8px 25px rgba(242, 106, 82, 0.4);
                }
            }

            .sparkle-effect {
                position: absolute;
                width: 100%;
                height: 100%;
                pointer-events: none;

                .sparkle {
                    position: absolute;
                    width: 3px;
                    height: 3px;
                    background: white;
                    border-radius: 50%;

                    &:nth-child(1) {
                        top: 15px;
                        right: 18px;
                        animation: sparkle-1 2s infinite;
                    }

                    &:nth-child(2) {
                        top: 20px;
                        left: 15px;
                        animation: sparkle-2 2s infinite 0.5s;
                    }

                    &:nth-child(3) {
                        bottom: 18px;
                        right: 22px;
                        animation: sparkle-3 2s infinite 1s;
                    }
                }
            }
        }
    }

    .rating-display {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: clamp(0.5rem, 1.5vw, 0.75rem);
        padding-top: clamp(0.75rem, 2vw, 1rem);
        border-top: 1px solid rgba(209, 213, 219, 0.6);

        .rating-value {
            display: flex;
            align-items: baseline;
            gap: clamp(0.25rem, 0.5vw, 0.375rem);
            font-weight: 600;

            .value {
                font-size: clamp(1.25rem, 3vw, 1.5rem);
                color: #f26a52;
                text-shadow: 0 1px 2px rgba(242, 106, 82, 0.3);
            }

            .divider {
                font-size: clamp(1rem, 2.2vw, 1.125rem);
                color: rgba(107, 114, 128, 0.8);
            }

            .max {
                font-size: clamp(1rem, 2.2vw, 1.125rem);
                color: rgba(107, 114, 128, 0.8);
            }
        }
    }
}

@keyframes sparkle-1 {
    0%, 100% {
        opacity: 0;
        transform: scale(0);
    }
    50% {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes sparkle-2 {
    0%, 100% {
        opacity: 0;
        transform: scale(0) rotate(0deg);
    }
    50% {
        opacity: 1;
        transform: scale(1.2) rotate(180deg);
    }
}

@keyframes sparkle-3 {
    0%, 100% {
        opacity: 0;
        transform: scale(0);
    }
    50% {
        opacity: 1;
        transform: scale(0.8);
    }
}

/* Alignment Classes */
.rating-scale-align-left {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    > label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .scale-container {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        > label, .field-label-input {
            width: 100%;
            text-align: left;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .scale-container {
            width: 100%;
        }
    }
}

.rating-scale-align-right {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    > label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .scale-container {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        > label, .field-label-input {
            width: 100%;
            text-align: left;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .scale-container {
            width: 100%;
        }
    }
}

.rating-scale-align-top {
    > label {
        text-align: left;
    }
}

@media (max-width: 768px) {
    .rating-scale {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .scale-container {
            padding: clamp(0.875rem, 2.5vw, 1.25rem);
            border-radius: clamp(0.5rem, 1.5vw, 0.75rem);
        }

        .scale {
            gap: clamp(0.5rem, 1.5vw, 0.75rem);
            margin-bottom: clamp(0.75rem, 2vw, 1rem);

            .circle {
                width: clamp(2.75rem, 6.5vw, 3.125rem);
                height: clamp(2.75rem, 6.5vw, 3.125rem);

                &:hover {
                    transform: scale(1.05);
                }

                .number {
                    font-size: clamp(0.875rem, 2.2vw, 1.125rem);
                }

                .label-container {
                    top: clamp(3.5rem, 8vw, 3.75rem);

                    .scale-label {
                        font-size: clamp(0.65rem, 1.4vw, 0.7rem);
                    }
                }

                .sparkle-effect .sparkle {
                    width: 2px;
                    height: 2px;
                }
            }
        }
    }
}

@media (prefers-reduced-motion: reduce) {
    .rating-scale, .circle, .scale-container {
        transition: none;
    }

    .circle:hover, .sparkle {
        transform: none;
        animation: none;
    }
}
</style>
